"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toTileGridSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toTileGridSlice = function (data, logger) {
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.TileGrid)), { ctaLabel: fields_1.toText(data.primary.ctaLabel), ctaImage: fields_1.toImage(data.primary.ctaImage, logger), tiles: data.items
            .map(function (item) { return fields_1.toDocumentLink(item.document, logger); })
            .filter(Boolean) }));
};
exports.toTileGridSlice = toTileGridSlice;
//# sourceMappingURL=tile-grid-slice.js.map